import { RootState } from '../store';

import { ILocationsListParamsState } from './locations-list.slice';

export const selectLocationsParamsSearch = (state: RootState): string =>
    state.locationsListParams.search;

export const selectLocationsParams = (state: RootState): ILocationsListParamsState =>
    state.locationsListParams;
